var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var PdfFileAssetIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 43,
    glyphHeight: 60
  }), React.createElement("path", {
    d: "M13.0217 0.782593L0.5 13.3043V59.2174H42.2391V0.782593H13.0217ZM38.0652 55.0435H4.67391V13.3043H13.0217V4.95651H38.0652V55.0435Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M27.4578 36V26.228H33.9398V28.118H29.5858V30.12H33.2958V31.996H29.5858V36H27.4578Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M17.696 26.228H21.378C22.022 26.228 22.61 26.3307 23.142 26.536C23.674 26.7414 24.1267 27.0494 24.5 27.46C24.8734 27.8614 25.1627 28.37 25.368 28.986C25.5734 29.5927 25.676 30.302 25.676 31.114C25.676 31.926 25.5734 32.64 25.368 33.256C25.1627 33.8627 24.8734 34.3714 24.5 34.782C24.1267 35.1834 23.674 35.4867 23.142 35.692C22.61 35.8974 22.022 36 21.378 36H17.696V26.228ZM21.378 34.11C22.0127 34.11 22.512 33.9327 22.876 33.578C23.24 33.2234 23.422 32.654 23.422 31.87V30.358C23.422 29.574 23.24 29.0047 22.876 28.65C22.512 28.2954 22.0127 28.118 21.378 28.118H19.824V34.11H21.378Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M8.50854 36V26.228H13.1285C13.5859 26.228 13.9965 26.3074 14.3605 26.466C14.7245 26.6154 15.0325 26.8254 15.2845 27.096C15.5459 27.3667 15.7465 27.698 15.8865 28.09C16.0265 28.4727 16.0965 28.8927 16.0965 29.35C16.0965 29.8167 16.0265 30.2414 15.8865 30.624C15.7465 31.0067 15.5459 31.3334 15.2845 31.604C15.0325 31.8747 14.7245 32.0894 14.3605 32.248C13.9965 32.3974 13.5859 32.472 13.1285 32.472H10.6365V36H8.50854ZM10.6365 30.624H12.8765C13.1939 30.624 13.4412 30.5447 13.6185 30.386C13.8052 30.218 13.8985 29.9754 13.8985 29.658V29.042C13.8985 28.7247 13.8052 28.4867 13.6185 28.328C13.4412 28.16 13.1939 28.076 12.8765 28.076H10.6365V30.624Z",
    fill: "black"
  }));
};
export var PdfFileAssetIconGlyph = function (props) {
  return React.createElement(PdfFileAssetIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};